import React from 'react';
import { Icon, AvailableIcons } from 'src/components-dummy';

export const DraggingHandle = (): JSX.Element => (
  <>
    <Icon name={AvailableIcons.EllipsisMenu} />
    <Icon name={AvailableIcons.EllipsisMenu} />
  </>
);
